import { Button } from "@/components/ui";
import type { RetryableLoad } from "@/hooks/use-retryable-load";
import { useT } from "@/i18n";
import { settingsShellMessages } from "@/i18n/messages/settings-shell";

/** The loading line or the failed-load alert with Retry for one Settings source. */
export function SettingsLoadStatus({
  state,
  noun,
  retryTestId,
}: {
  state: Pick<RetryableLoad<unknown>, "loading" | "error" | "retry">;
  /** Translated by the caller: "this plugin", "installed plugins". */
  noun: string;
  retryTestId: string;
}) {
  const t = useT(settingsShellMessages);
  if (state.loading)
    return (
      <p role="status" className="px-2 py-1 text-appkit-small text-muted">
        {t("loadingNoun", { noun })}
      </p>
    );
  if (!state.error) return null;
  return (
    <div role="alert" className="px-2 py-1">
      <p className="text-appkit-small text-danger">
        {t("loadFailedNoun", { noun })}
      </p>
      <Button
        size="sm"
        data-testid={retryTestId}
        aria-label={t("retryNoun", { noun })}
        onClick={state.retry}
      >
        {t("retry")}
      </Button>
    </div>
  );
}
